const shadow = {
  '--textarea-shadow': undefined,
}

export default shadow
